import { Flex, Typography } from 'antd'
import styled, { css } from 'styled-components'
import { IconButton } from '../Button'
import { mediaMax } from '@/app/styles/breakpoints'

export const TransferContainer = styled.div`
  .ant-transfer-operation *,
  .ant-transfer-list-header {
    display: none;
  }

  .ant-transfer {
    gap: 16px;
    ${mediaMax.sm} {
      flex-direction: column;
      gap: 24px;
    }
  }

  .ant-transfer-operation {
    width: 1px;
    min-height: 100%;
    background-color: ${(props) => props.theme.colors.divider};
    align-self: stretch;
    ${mediaMax.sm} {
      display: none;
    }
  }

  .ant-transfer-list {
    display: flex;
    flex-direction: column;
    height: 100%;
    border: none;
    ${mediaMax.sm} {
      flex: 0 0 auto;
    }
  }

  .ant-transfer-list-body {
    flex: 1;
    display: flex;
    flex-direction: column;
    min-height: 0;
  }

  .ant-transfer-list-content {
    flex: 1;
    overflow-y: auto;
  }

  .ant-transfer-list-body-customize-wrapper {
    display: flex;
    flex-direction: column;
    height: 100%;
    min-height: 0;
  }
`

export const Content = styled(Flex)`
  height: 100%;
`

export const ButtonWrapper = styled(Flex)``

export const List = styled.div`
  overflow-y: auto;
  flex: 1;
  min-height: 0;
  border-radius: 6px;
  border: 1px solid ${(props) => props.theme.colors.divider};
`

export const ObjectItem = styled(Flex)<{
  $isSelected?: boolean
  $isLeft?: boolean
}>`
  cursor: pointer;
  height: 40px;
  padding: 0 12px 0 8px;
  border-bottom: 1px solid ${(props) => props.theme.colors.divider};
  background-color: ${(props) =>
    props.$isSelected && props.$isLeft
      ? props.theme.colors.grayBackground
      : 'none'};

  ${(props) =>
    (props.$isLeft && !props.$isSelected) || !props.$isLeft
      ? css`
          &:hover {
            ${ObjectTitle} {
              color: ${(props) => props.theme.colors.primary};
            }
            ${ObjectCheck} {
              background-color: ${(props) =>
                props.theme.colors.button.invisible.active};
              svg {
                fill: ${(props) => props.theme.colors.text};
              }
            }
          }
        `
      : ''}
  ${(props) =>
    props.$isLeft && props.$isSelected
      ? css`
          ${ObjectCheck} {
            border-color: ${props.theme.colors.checkbox.border};
          }
        `
      : ''}
`

export const ObjectTitle = styled(Typography.Text)`
  flex: 1;
  font-size: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const ObjectCheck = styled(IconButton)`
  background-color: ${(props) => props.theme.colors.grayBackground};
  svg {
    fill: ${(props) => props.theme.colors.radio.border};
  }
`

export const VirtualListWrapper = styled.div`
  flex: 1;
  width: 100%;

  .ReactVirtualized__List {
    scrollbar-width: thin;
    scrollbar-color: ${(props) => props.theme.colors.divider} transparent;
    border: 1px solid ${(props) => props.theme.colors.divider};
    border-radius: 6px;

    &::-webkit-scrollbar {
      width: 4px;
    }

    &::-webkit-scrollbar-track {
      background: transparent;
      border-radius: 2px;
    }

    &::-webkit-scrollbar-thumb {
      background: ${(props) => props.theme.colors.divider};
      border-radius: 2px;
    }

    &::-webkit-scrollbar-thumb:hover {
      background: ${(props) => props.theme.colors.text};
    }

    &::-webkit-scrollbar-button {
      display: none;
    }
  }
`
